import { render, staticRenderFns } from "./optToggle.vue?vue&type=template&id=fe98d6a0&scoped=true"
import script from "./optToggle.vue?vue&type=script&lang=js"
export * from "./optToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe98d6a0",
  null
  
)

export default component.exports